import request from '@/utils/request';
import { downLoad } from '@/utils';
import { T } from '@/utils';
import axios from 'axios';
import router from '@/router';

const api = '/ddp/vehicle/';
const generationApi = '/ddp/generation/';

export default {
    createVehicle(data: Record<string, string | boolean>) {
        return request.post(`${api}createNewVehicleType`, data);
    },
    getDefaultVehicleType() {
        return request.get(`${api}getDefaultVehicleType`);
    },
    updateVehicleInfo(data: any) {
        return request.post(`${api}updateVehicleInfo`, data);
    },
    getFGList(data: Record<string, string | number | boolean | undefined>, uuid?: string) {
        return request.get(`${api}getEcuFgList`, data, {
            headers: {
                uuid: uuid
            }
        });
    },
    getVehicleTypesByUser() {
        return request.get(`${api}getVehicleTypesByUser`);
    },
    getVehicleInfo(params: Record<string, string>) {
        return request.get(`${api}getVehicleInfo`, params);
    },
    download(id: string) {
        downLoad(`${api}downloadODXFile?guuid=${id}`, {});
    },
    createECUFG(data: Record<string, string | boolean>) {
        return request.post(`${api}createEcuFg`, data);
    },
    delECUFG(id: number) {
        return request.post(`${api}deleteEcuFg`, { id });
    },
    editECUFG(data: any) {
        return request.post(`${api}updateEcuFg`, data);
    },
    deleteEcuBvFile(data: Record<string, any>) {
        // 删除BV的文件
        return request.post(`${api}deleteEcuBvFile?inputId=${data.inputId}&bvId=${data.bvId}&type=${data.type}`);
    },
    deleteEcuEvFile(data: Record<string, any>) {
        return request.post(`${api}deleteEcuEvFile?inputId=${data.inputId}&evId=${data.evId}`);
    },
    deleteXmEcuBvFile(data: Record<string, any>) {
        // 删除BV的文件
        return request.post(`${api}deleteXmEcuBvFile?inputId=${data.inputId}&bvId=${data.bvId}&type=${data.type}`);
    },
    deleteXmEcuEvFile(data: Record<string, any>) {
        return request.post(`${api}deleteXmEcuEvFile?inputId=${data.inputId}&evId=${data.evId}&type=${data.type}`);
    },
    deleteEcuFgFile(data: Record<string, any>) {
        return request.post(`${api}deleteEcuFgFile?inputId=${data.inputId}&fgId=${data.fgId}`);
    },
    deleteVehicleInfoFile(data: Record<string, any>) {
        return request.post(`${api}deleteVehicleInfoFile?inputId=${data.inputId}`);
    },

    startTemplateReport(data: Record<string, any>) {
        return request.post(`${generationApi}startTemplateReport?odxName=${data.odxName}`);
    },
    checkTemplateReportStatus(data: Record<string, any>) {
        return request.get(`${generationApi}checkTemplateReportStatus`, data, { hiddeGlobalNotification: true });
    },
    async downloadTemplate(url: string, headers: any) {
        try {
            const downLoadNotify = ElNotification({
                title: 'Notice',
                message: T('Tip.downloading'),
                type: 'info',
                duration: 3000
            });
            const response: any = await axios
                .get(generationApi + url, {
                    headers,
                    responseType: 'blob',
                    withCredentials: true,
                    xsrfCookieName: 'XSRF-TOKEN',
                    xsrfHeaderName: 'X-XSRF-TOKEN',
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                })
                .catch((e) => {
                    if (e.response.status === 401) {
                        downLoadNotify.close();
                        // ElNotification({
                        //     title: T('ApiTip.warning'),
                        //     message: T('Tip.expired'),
                        //     type: 'warning',
                        //     duration: 3000
                        // });
                        router.push('/login');
                        return;
                    }
                });
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const json = await response.data.text();
                const data = JSON.parse(json);
                if (data.result === 10802) {
                    downLoadNotify.close();
                    // ElNotification({
                    //     title: T('ApiTip.warning'),
                    //     message: data.message ?? T('Tip.reportGeneration'),
                    //     type: 'warning',
                    //     duration: 3000
                    // });
                } else {
                    // ElNotification({
                    //     title: T('ApiTip.warning'),
                    //     message: T('Tip.downLoadEmpty'),
                    //     type: 'warning'
                    // });
                }
            }
            let filename = '';
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const matches = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^"';]*)['"]?;?/i);
                if (matches && matches[1]) {
                    filename = decodeURIComponent(matches[1]);
                }
            }
            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download error:', error);
        }
    },
    checkOutputPattern(data: any) {
        return request.get(`${api}checkOutputPattern`, data);
    },
    getVehicleTypeUserList(params: Record<string, string>) {
        return request.get(`${api}getVehicleTypeUserList`, params);
    },
    getVehicleTypeListWithUsers(params: Record<string, string>) {
        return request.get(`${api}getVehicleTypeListWithUsers`, params);
    },
    updateVehicleTypeUserList(data: any) {
        return request.post(`${api}updateVehicleTypeUserList`, data);
    },
    setEcuFgDefault(fgId: string | number) {
        return request.get(`${api}setEcuFgDefault`, { fgId });
    },
    getEcuFgBvList(fgId: string | number) {
        return request.get(`${api}getEcuFgBvList`, { fgId });
    },
    getGenerateType() {
        return request.get(`${api}getGenerateType`);
    },
    getComParamExtend(type: string, data?: Record<string, any>) {
        return request.get(`${api}getComParamExtend?type=${type}`, data);
    }
};
